export default "__VITE_ASSET__c1f55a99__"